import { render, staticRenderFns } from "./PanelistLandingPage.vue?vue&type=template&id=5ff39792"
import script from "./PanelistLandingPage.vue?vue&type=script&lang=ts"
export * from "./PanelistLandingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports